export const MENU = [
  { id: 'inicio', label: 'Inicio', icone: 'Home', adminOnly: false },
  { id: 'links', label: 'Links Uteis', icone: 'Link2', adminOnly: false },
  { id: 'vendas', label: 'Lancar Venda', icone: 'FilePlus2', adminOnly: false },
  { id: 'minhasVendas', label: 'Minhas Vendas', icone: 'ClipboardList', adminOnly: false },
  { id: 'dashboard', label: 'Dashboard', icone: 'LayoutDashboard', adminOnly: true },
  { id: 'bi', label: 'Analise BI', icone: 'LineChart', adminOnly: true },
  { id: 'metas', label: 'Metas', icone: 'Target', adminOnly: false },
  { id: 'tabela', label: 'Tabela Comissao', icone: 'Table2', adminOnly: false },
  { id: 'comissao', label: 'Minhas Comissoes', icone: 'Wallet', adminOnly: false },
  { id: 'pagamentos', label: 'Pagamentos', icone: 'CreditCard', adminOnly: true },
  { id: 'contasPagar', label: 'Financeiro', icone: 'Briefcase', adminOnly: true },
  { id: 'sorteios', label: 'Sorteios', icone: 'Dices', adminOnly: false },
  { id: 'cotas', label: 'Cotas Contempladas', icone: 'Award', adminOnly: false },
  { id: 'proposta', label: 'Proposta Comercial', icone: 'FileText', adminOnly: false },
  { id: 'historicoPropostas', label: 'Historico de Propostas', icone: 'History', adminOnly: false },
  { id: 'minhaSenha', label: 'Minha Senha', icone: 'KeyRound', adminOnly: false },
  { id: 'crm', label: 'CRM', icone: 'Users', adminOnly: false },
  { id: 'importar', label: 'Importacao', icone: 'FolderInput', adminOnly: true },
  { id: 'config', label: 'Configuracoes', icone: 'Settings', adminOnly: true },
  { id: 'master', label: 'Master', icone: 'Compass', adminOnly: false, masterOnly: true }
]
